import React, { createContext, useContext, type ReactNode } from 'react';
import type { FormControlModelExtended } from './types';
import type { FormFieldModel } from '@generated';

interface FormControlsAndFieldsProviderProps {
	formControls: FormControlModelExtended[];
	formFields: FormFieldModel[];
	children: ReactNode;
}

interface FormControlsAndFieldsContextValue {
	formControls: FormControlModelExtended[];
	formFields: FormFieldModel[];
}

export const FormControlsAndFieldsContext = createContext<FormControlsAndFieldsContextValue | undefined>(undefined);

export function FormControlsAndFieldsContextProvider(props: FormControlsAndFieldsProviderProps) {
	return <FormControlsAndFieldsContext.Provider value={props}>{props.children}</FormControlsAndFieldsContext.Provider>;
}

export function useFormControlsAndFields() {
	return useContext(FormControlsAndFieldsContext);
}
